/* eslint-disable import/namespace */
import React, { useEffect } from "react";
import {BrowserRouter as Router } from "react-router-dom";
import {Navigation} from "./routes";
import "./config/AxiosConfig"
import "bootstrap/dist/css/bootstrap.min.css";
import { useJsApiLoader } from "@react-google-maps/api";
import defaultConfig from "./config/Config";
import { useDispatch } from "react-redux";
import { setGoogleMapApiLoaded } from "./slices/InitialDataSlice";
//import $ from "jquery";
//import Popper from "popper.js";
const libraries = ["places"];
function App() {
  const dispatch = useDispatch()
  const {isLoaded} = useJsApiLoader({ 
                          googleMapsApiKey: defaultConfig.mapKey, 
                          libraries
                      })
  useEffect(() => {

    dispatch(setGoogleMapApiLoaded(isLoaded))

  }, [dispatch, isLoaded])

  return ( 
    <Router basename="/premgreen-admin">
      <Navigation/>
    </Router>
    
  );
}
export default App;
 